import { render } from "./Leavestats.vue?vue&type=template&id=5a34fb2e&scoped=true"
import script from "./Leavestats.vue?vue&type=script&lang=js"
export * from "./Leavestats.vue?vue&type=script&lang=js"

import "./Leavestats.vue?vue&type=style&index=0&id=5a34fb2e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a34fb2e"]])

export default __exports__